import { EntityMetadata } from '@ngrx/data';
import { HttpResourceUrls } from '@ngrx/data/src/dataservices/http-url-generator';
import { Strategy } from '../../../core/model/central/strategy.model';

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const strategyEntityMetadata: EntityMetadata<Strategy> = {
    entityName: 'Strategy',
    selectId: strategySelectId // .id is used if doing optimistic update
    // additionalCollectionState: {
    //     userId: 1 // extra properties
    // }
    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

export const strategyHttpResourceUrls: HttpResourceUrls = {
    entityResourceUrl : 'servlets/strategies/entity/',
      collectionResourceUrl: 'servlets/strategies/entities/'
};

// tslint:disable-next-line:only-arrow-functions typedef
export function strategySelectId<T extends { id: any }>(strategy: Strategy) {
    return  strategy === undefined ? undefined : strategy.id || strategy.strategyId;  // .id is used if doing optimistic update
}
